import { useAuth0 } from "@auth0/auth0-react";
import { clearCompanyLogoCache } from "../pages/company/components/CompanyLogo";

const POST_LOGOUT_KEY = "@@uam/post_logout@@";
const LOGOUT_CHANNEL = "@@uam/logout@@";
const LOGOUT_MESSAGE = "logout";

const clearAuth0Tokens = (): void => {
  Object.keys(localStorage)
    .filter((key) => key.startsWith("@@auth0spajs@@"))
    .forEach((key) => localStorage.removeItem(key));
};

export const useLogout = (): (() => void) => {
  const { logout } = useAuth0();

  return (): void => {
    const channel = new BroadcastChannel(LOGOUT_CHANNEL);
    channel.postMessage(LOGOUT_MESSAGE);
    channel.close();
    clearAuth0Tokens();
    clearCompanyLogoCache();
    localStorage.setItem(POST_LOGOUT_KEY, "1");
    sessionStorage.clear();
    void logout({
      logoutParams: {
        returnTo: globalThis.location.origin,
        federated: true,
      },
    });
  };
};

export { LOGOUT_CHANNEL, LOGOUT_MESSAGE, POST_LOGOUT_KEY };
